<script setup>
import { useProjectUserStore } from '@/stores/project_user'

const store = useProjectUserStore()
import RHDHVButton from '@/components/common/RHDHVButton.vue'
</script>

<template>
  <v-card elevation="0" variant="flat">
    <v-card-title>
      Speckle management
    </v-card-title>
    <v-card-subtitle>
      Please configure your Speckle settings.
    </v-card-subtitle>
  </v-card>
</template>

<style scoped>
.v-card-title {
  display: flex;
  align-items: center;
}
</style>
